import AccountPayable from "../../AccountPayable/components/AccountPayable";
import PartnerInfoToolTip from "../../../components/PartnerInfoTooltip";
import { FormatNumber, FormatNumberOrNull } from "utils/numberUtils";
import InfoIcon from "../../../../../images/info-icon.png";
import { useSelector } from "react-redux";
import { selectPartner, selectState } from "../main.slice";
import { useAppDispatch } from "hooks/hooks";
import { AccountReceivable } from "../../AccountReceivable/components";
import Popover from "components/Popover/Popover";
import { IPopoverState } from "Dashboard/scenes/Carnets/domain/IPopoverState";
import { useState } from "react";
import InfoTooltip from "components/Popup/InfoTooltip";

export const PartnerDetails = () => {
  const partner = useSelector(selectPartner);
  const dispatch = useAppDispatch();
  const {
    payablesTotalOutstandingAmount,
    payablesTotalOutstandingXxxAmount,
    receivablesTotalDebtAmount,
    payablesPlanAmount,
    receivablesPlanAmount
  } = useSelector(selectState);
  const [popover, setPopover] = useState<IPopoverState>({ isOpen: false });

  return (
    <div className="partners-paying">
      <div className="header">
        <div className="g-grid g-footer">
          <div className="row">
            <div />
            <div className="col">
              <div className="bg-item bg-item-border-light right">
                <span className="light">{FormatNumberOrNull(receivablesTotalDebtAmount)}</span>
              </div>
            </div>
            <div />
            <div className="col">
              <div className="bg-item bg-item-border-light">
                <span className="light">{FormatNumberOrNull(payablesTotalOutstandingAmount)}</span>
              </div>
            </div>
            <div></div>
            <div className="col">
              <div className="bg-item bg-item-border-light center">
                <span className="light">{FormatNumberOrNull(payablesTotalOutstandingXxxAmount)}</span>
              </div>
            </div>
            <div />
            <div className="col">
              <div className="bg-item bg-item-border-dotted bg-transparent center">
                <span className="strong red">
                  {receivablesPlanAmount && FormatNumber(receivablesPlanAmount)}
                </span>
              </div>
            </div>
            <div />
            <div className="col">
              <div className="bg-item bg-item-border-dotted bg-transparent center">
                <span className="strong red">
                  {payablesPlanAmount && FormatNumber(payablesPlanAmount)}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="info">
          <InfoTooltip tooltip="Info" classesProp="icon" onClick={() => setPopover({ isOpen: true })}>
            <img src={InfoIcon} alt="" />
          </InfoTooltip>

          <span className="text">{partner?.shortName}</span>
        </div>
      </div>
      <div className="paying-details">
        <div className="left">
          <AccountReceivable />
        </div>
        <div className="right">
          <AccountPayable />
        </div>
      </div>
      <Popover
        isOpen={popover.isOpen}
        onClose={() => setPopover({ isOpen: false })}
        title="Info"
        direction="right"
        arrowStyle={{ top: "50%" }}
        position={{ top: 335, left: 147 }}
      >
        <PartnerInfoToolTip selectedPartner={partner} dispatch={dispatch} />
      </Popover>
    </div>
  );
};
